(function () {
    'use strict';

    angular
        .module('Lavpop-store.services')
        .service('UnavailableProductService', UnavailableProductService)

    /** @ngInject */
    function UnavailableProductService(HttpService) {
        const UnavailableProductService = {
            post: post
        }

        return UnavailableProductService;

        function post(unavailableProductData) {
            return HttpService.post('/unavailable-products', unavailableProductData);
        }
    }
}());